/**
 * Profil autorisé — rempli uniquement par GET /api/profile/ (ou login).
 * Ne jamais faire confiance à sessionStorage pour les décisions d'accès.
 */
let verifiedProfile = null;

function normalizeRole(role) {
  return String(role || '').trim().toLowerCase();
}

export function setVerifiedProfile(userData) {
  if (!userData || typeof userData !== 'object') {
    verifiedProfile = null;
    return;
  }
  const role = normalizeRole(
    userData.role || userData.user_role || userData.userRole
  );
  const permissions = Array.isArray(userData.permissions)
    ? userData.permissions.filter(Boolean).map(String)
    : [];
  verifiedProfile = {
    role,
    role_employe: String(userData.role_employe || '').trim().toLowerCase(),
    permissions,
    is_staff: Boolean(userData.is_staff),
    is_superuser: Boolean(userData.is_superuser),
    verified_at: Date.now(),
  };
}

export function clearVerifiedProfile() {
  verifiedProfile = null;
}

export function hasVerifiedProfile() {
  return verifiedProfile != null && !!verifiedProfile.role;
}

export function getVerifiedRole() {
  return verifiedProfile?.role || '';
}

export function getVerifiedPermissions() {
  return verifiedProfile?.permissions ? [...verifiedProfile.permissions] : [];
}

export function getVerifiedRoleEmploye() {
  return verifiedProfile?.role_employe || '';
}

export function isVerifiedAdmin() {
  const role = getVerifiedRole();
  return role === 'admin' || Boolean(verifiedProfile?.is_superuser);
}

export function verifiedHasPermission(permission) {
  if (!hasVerifiedProfile()) return false;
  if (isVerifiedAdmin()) return true;
  return getVerifiedPermissions().includes(permission);
}

export function verifiedHasAnyPermission(required) {
  if (!hasVerifiedProfile()) return false;
  if (isVerifiedAdmin()) return true;
  const req = Array.isArray(required) ? required : [required];
  const perms = getVerifiedPermissions();
  return req.some((p) => perms.includes(p));
}
